import { CMCard, CMCardDescription, CMCardTitle } from "./metric-item.styles";
import { ReactComponent as ArrowIcon } from '../../../icons/arrow.svg';
import Button from "../../button/button.component";
import LoadingChild from "../../loading-child/loading-child.component";
import { TransactionContend } from "../../funds-menu/funds-menu.component.styles";
import arrowUpdate from '../../../icons/arrow-update.png';
import HelpTooltip from "../../help-tooltip/help-tooltip.component";

const MetricItem = ({data, loading, ButtonClick}) => {
    const {items, title, subtitle, button, className} = data;
    return (
        <CMCard>
            <CMCardTitle>
                <div>
                <h4 className={className}>{title}</h4>
          {title === "Portfolio Value" && (
            <TransactionContend
              className="transaction-button"
              onClick={ButtonClick}
            >
            {!loading && 
            <>
            <p style={{marginTop:"0px"}}>{items.length === 4 ? items[3].portfolioValue : items[2].portfolioValue}</p>
            <img src={arrowUpdate} /> 
            </>
            }
            {/*<span style={{color: "rgb(0, 112, 224)", textDecoration:"underline"}}>
                Refresh
            </span>
            <img style={{position:"absolute", top:"20px",right:"10px"}} src={arrowUpdate} />*/}
            </TransactionContend>
          )}
          <ArrowIcon />
        </div>
                <span>{subtitle}</span>
            </CMCardTitle>
            <CMCardDescription>
                {loading ? (
                    <div>
                        <LoadingChild />
                    </div>
                ) : (
                    <>
                        {items && items.length > 0 &&
                            items.map((item, index) => (
                                <div key={index} className={item.className}>
                                    <p style={{display:"flex", gap:"0.5rem"}}>
                                        {item.title}
                                        {item?.tooltipTitle &&
                                        <HelpTooltip title={item?.tooltipTitle} />
                                        }
                                    </p>
                                    
                                    <p style={item.style}>
                                        <span style={{ color: "green", fontSize: "14px" }}>{item.subContent ? item.subContent : ""}</span>
                                        {item.value}</p>
                                </div>
                            ))
                            }
                        {button &&
                            <div>
                                <Button size='small' color='blue' style={{ margin: 'auto' }}>
                                    {button}
                                </Button>
                            </div>
                        }
                    </>
                )}
            </CMCardDescription>
        </CMCard>
    );
}

export default MetricItem; 